export enum Environment {
  Development = 'development',
  Test = 'test',
  Preview = 'preview',
  Staging = 'staging',
  Experimental = 'experimental',
  Production = 'production',
}

export function getEnvironment(): Environment {
  const { NODE_ENV, CONTENTFUL_PREVIEW, STAGING, EXPERIMENTAL } = process.env

  if (STAGING === 'true') {
    return Environment.Staging
  }

  switch (NODE_ENV) {
    case 'test':
      return Environment.Test

    case 'production':
      if (CONTENTFUL_PREVIEW === 'true') {
        return Environment.Preview
      }

      if (EXPERIMENTAL === 'true') {
        return Environment.Experimental
      }

      return Environment.Production

    default:
      return Environment.Development
  }
}

export function isTestEnvironment(): boolean {
  return getEnvironment() === Environment.Test
}
